import { PortfolioData } from "../../portfolio/types";
import { ValueAndDateTime } from "../models/dados-indicadores.model";
import { RopPortfolioSSEData } from "../models/portfolio.model";

export function ropSSEEventToPortfolioData(
  ropCard: RopPortfolioSSEData
): PortfolioData {
  return {
    energiaGeradaTotal: ropCard.energiaGeradaTotal,
    disponibilidade: ropCard.disponibilidade,
    prRealizado: ropCard.prRealizado,
    performanceRatio: ropCard.performanceRatio,
    prPrevisto: ropCard.prPrevisto,
    usinas: ropCard.usinas,
    potenciaAtiva: ropCard.potenciaAtiva,
    potenciaEsperada: ropCard.potenciaEsperada,
    energiaIdeal: ropCard.energiaIdeal,
    energiaPrevista: ropCard.energiaPrevista,
    receitaEstimada: ropCard.receitaEstimada,
    irradianciaMedia: ropCard.irradianciaMedia,
    temperaturaMedia: ropCard.temperaturaMedia,
    inversoresOffline: ropCard.inversoresOffline,
    inversoresBaixaEficiencia: ropCard.inversoresBaixaEficiencia,
    energiaGeradaAtDayByHour: ropCard.energiaGeradaAtDayByHour as ValueAndDateTime[],
    irradianciaMediaByHour: ropCard.irradianciaMediaByHour as ValueAndDateTime[],
    irradianciaMediaAtMinutes: ropCard.irradianciaMediaAtMinutes as ValueAndDateTime[],
    potenciaAtivaAtMinutes: ropCard.potenciaAtivaAtMinutes as ValueAndDateTime[]
  };
}
